var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-icon-name": "call",
    "data-style": "line-color",
    icon_origin_id: 16071,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Line Color",
    id: "call",
    className: "icon line-color",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(19, 180, 196)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12,7a5,5,0,0,1,5,5",
    id: "secondary"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(19, 180, 196)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11,3.06A8.26,8.26,0,0,1,12,3a9,9,0,0,1,9,9,8.26,8.26,0,0,1-.06,1",
    "data-name": "secondary",
    id: "secondary-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(16, 47, 116)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15,21a13.21,13.21,0,0,1-4.34-1.91l1.82-2.61a2,2,0,0,1,2.68-.51c.33.21.67.4,1,.59A2,2,0,0,1,17,19.38l-.62.95A1.17,1.17,0,0,1,15,21ZM3.67,7.67l1-.62a2,2,0,0,1,2.85.73c.19.36.38.7.59,1a2,2,0,0,1-.51,2.68L4.94,13.31A13.21,13.21,0,0,1,3,9,1.17,1.17,0,0,1,3.67,7.67Z",
    id: "primary"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(16, 47, 116)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4.94,13.31a17.72,17.72,0,0,0,2.58,3.17,17.72,17.72,0,0,0,3.17,2.58",
    "data-name": "primary",
    id: "primary-2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone_call.a990b8403bd150c6e4dc78476ca950b4.svg";
export { ForwardRef as ReactComponent };